import { useLayoutEffect, useRef } from "react";
import { useVideoCall } from "contexts/VideoCallContext.jsx";

/**
 * Renders the in-page mount point for the live video call. The actual
 * InlineVideoCall is owned by VideoCallProvider (in PatientLayout) and lives in
 * a persistent DOM node; this slot adopts that node into its own element while
 * mounted and releases it back to the hidden holder on unmount. Reparenting —
 * rather than rendering InlineVideoCall here — is what keeps the Chime session
 * alive when the doctor navigates to other patient tabs.
 */
export const VideoCallSlot = ({ className }) => {
  const { videoHost, parkHost } = useVideoCall();
  const slotRef = useRef(null);

  useLayoutEffect(() => {
    const slot = slotRef.current;
    if (!slot || !videoHost) return;

    slot.appendChild(videoHost);

    return () => parkHost();
  }, [videoHost, parkHost]);

  return <div ref={slotRef} className={className} />;
};
